var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"templates-pop-up p-3 text-center"},[_c('h4',[_vm._v(_vm._s(_vm.message.title))]),_c('div',{staticClass:"text-secondary mb-4 text-left",domProps:{"innerHTML":_vm._s(_vm.message.text)}}),_c('button',{staticClass:"btn btn-primary px-5",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Fechar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }